import * as React from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider } from "@fluentui/react-components";
import { brandTheme } from "../taskpane/theme";
import { AuthModule } from "../taskpane/services/authModule";
import { loadConfig } from "../taskpane/config";
import { LoginScreen } from "../taskpane/components/LoginScreen";

/* global document, Office */

const COOKIE_NAME = "mfai-id-token";

function setCookie(name: string, value: string, maxAgeSecs: number): void {
  document.cookie = `${name}=${value}; path=/; max-age=${maxAgeSecs}; secure; samesite=none`;
}

const auth = new AuthModule();

const LoginApp: React.FC = () => {
  const [error, setError] = React.useState<string | null>(null);

  const handleSignIn = async () => {
    try {
      const tokens = await auth.signIn();
      const expiresIn = Math.floor((tokens.expiresAt - Date.now()) / 1000);
      setCookie(COOKIE_NAME, tokens.idToken, expiresIn);
      sessionStorage.setItem("mf-tokens", JSON.stringify(tokens));
      window.location.href = "/taskpane.html";
    } catch (e) {
      setError(e instanceof Error ? e.message : "Sign-in failed.");
    }
  };

  return React.createElement(LoginScreen, { onLogin: handleSignIn, error });
};

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

Office.onReady(async () => {
  await loadConfig();
  root?.render(
    React.createElement(FluentProvider, { theme: brandTheme, style: { minHeight: "100vh" } },
      React.createElement(LoginApp)
    )
  );
});
